
        var result = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js!./in-place-restore.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/in-place-restore/in-place-restore.scss
// module id = 3aGH
// module chunks = 0